import React from 'react';
import { FaFilePdf } from "react-icons/fa";

const PublicationEntry = (props) => (
	<tr className={props.className+'tr'}>
		{props.enabled === true?
			<td  onClick={props.onClick} className={props.className === "commission-selector-entry"?props.className+"-clickable":props.className}>{props.publicationTitle}</td>:
			<td  className={props.className === "commission-selector-entry"?props.className : props.className}>{props.publicationTitle}</td>
		}
		<td className={props.className}>{props.publicationTypeName}</td>
		<td className={props.className}>{props.publicationDate}</td>
		<td className={props.enabled === true?props.className+"-clickable":props.className}>{props.enabled === true && props.publicationFileUrl ?<FaFilePdf
						 className="editBtn"
						 onClick={() => window.open(props.publicationFileUrl, "_blank")}/>
						 : "" + props.publicationFileUrl + "" + props.status

		}


		</td>
	</tr>
);

export default PublicationEntry;


// WEBPACK FOOTER //
// ./src/publications/components/PublicationEntry.js